"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useArrowContainer = void 0;
var react_1 = require("react");
var useArrowContainer = function (_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowSize = _a.arrowSize, arrowColor = _a.arrowColor;
    var arrowContainerStyle = react_1.useMemo(function () {
        return ({
            padding: arrowSize,
        });
    }, [arrowSize]);
    var arrowStyle = react_1.useMemo(function () {
        return (__assign({ position: 'absolute' }, (function () {
            var arrowWidth = arrowSize * 2;
            var top = childRect.top - popoverRect.top + childRect.height / 2 - arrowWidth / 2;
            var left = childRect.left - popoverRect.left + childRect.width / 2 - arrowWidth / 2;
            var lowerBound = arrowSize;
            var leftUpperBound = popoverRect.width - arrowSize;
            var topUpperBound = popoverRect.height - arrowSize;
            left = left < lowerBound ? lowerBound : left;
            left = left + arrowWidth > leftUpperBound ? leftUpperBound - arrowWidth : left;
            top = top < lowerBound ? lowerBound : top;
            top = top + arrowWidth > topUpperBound ? topUpperBound - arrowWidth : top;
            top = Number.isNaN(top) ? 0 : top;
            left = Number.isNaN(left) ? 0 : left;
            switch (position) {
                case 'right':
                    return {
                        borderTop: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid " + arrowColor,
                        left: 0,
                        top: top,
                    };
                case 'left':
                    return {
                        borderTop: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid transparent",
                        borderLeft: arrowSize + "px solid " + arrowColor,
                        right: 0,
                        top: top,
                    };
                case 'bottom':
                    return {
                        borderLeft: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid " + arrowColor,
                        top: 0,
                        left: left,
                    };
                case 'top':
                default:
                    return {
                        borderLeft: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid transparent",
                        borderTop: arrowSize + "px solid " + arrowColor,
                        bottom: 0,
                        left: left,
                    };
            }
        })()));
    }, [
        arrowColor,
        arrowSize,
        childRect.height,
        childRect.left,
        childRect.top,
        childRect.width,
        popoverRect.height,
        popoverRect.left,
        popoverRect.top,
        popoverRect.width,
        position,
    ]);
    return {
        arrowContainerStyle: arrowContainerStyle,
        arrowStyle: arrowStyle,
    };
};
exports.useArrowContainer = useArrowContainer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQXJyb3dDb250YWluZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlQXJyb3dDb250YWluZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQkFBZ0M7QUFHekIsSUFBTSxpQkFBaUIsR0FBRyxVQUFDLEVBTVQ7UUFMdkIsU0FBUyxlQUFBLEVBQ1QsV0FBVyxpQkFBQSxFQUNYLFFBQVEsY0FBQSxFQUNSLFNBQVMsZUFBQSxFQUNULFVBQVUsZ0JBQUE7SUFFVixJQUFNLG1CQUFtQixHQUFHLGVBQU8sQ0FDakM7UUFDRSxPQUFBLENBQUM7WUFDQyxPQUFPLEVBQUUsU0FBUztTQUNLLENBQUE7SUFGekIsQ0FFeUIsRUFDM0IsQ0FBQyxTQUFTLENBQUMsQ0FDWixDQUFDO0lBRUYsSUFBTSxVQUFVLEdBQUcsZUFBTyxDQUN4QjtRQUNFLE9BQUEsQ0FBQyxXQUNDLFFBQVEsRUFBRSxVQUFVLElBQ2pCLENBQUM7WUFDRixJQUFNLFVBQVUsR0FBRyxTQUFTLEdBQUcsQ0FBQyxDQUFDO1lBQ2pDLElBQUksR0FBRyxHQUFHLFNBQVMsQ0FBQyxHQUFHLEdBQUcsV0FBVyxDQUFDLEdBQUcsR0FBRyxTQUFTLENBQUMsTUFBTSxHQUFHLENBQUMsR0FBRyxVQUFVLEdBQUcsQ0FBQyxDQUFDO1lBQ2xGLElBQUksSUFBSSxHQUFHLFNBQVMsQ0FBQyxJQUFJLEdBQUcsV0FBVyxDQUFDLElBQUksR0FBRyxTQUFTLENBQUMsS0FBSyxHQUFHLENBQUMsR0FBRyxVQUFVLEdBQUcsQ0FBQyxDQUFDO1lBRXBGLElBQU0sVUFBVSxHQUFHLFNBQVMsQ0FBQztZQUM3QixJQUFNLGNBQWMsR0FBRyxXQUFXLENBQUMsS0FBSyxHQUFHLFNBQVMsQ0FBQztZQUNyRCxJQUFNLGFBQWEsR0FBRyxXQUFXLENBQUMsTUFBTSxHQUFHLFNBQVMsQ0FBQztZQUVyRCxJQUFJLEdBQUcsSUFBSSxHQUFHLFVBQVUsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7WUFDN0MsSUFBSSxHQUFHLElBQUksR0FBRyxVQUFVLEdBQUcsY0FBYyxDQUFDLENBQUMsQ0FBQyxjQUFjLEdBQUcsVUFBVSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7WUFDL0UsR0FBRyxHQUFHLEdBQUcsR0FBRyxVQUFVLENBQUMsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDO1lBQzFDLEdBQUcsR0FBRyxHQUFHLEdBQUcsVUFBVSxHQUFHLGFBQWEsQ0FBQyxDQUFDLENBQUMsYUFBYSxHQUFHLFVBQVUsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDO1lBRTFFLEdBQUcsR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQztZQUNsQyxJQUFJLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7WUFFckMsUUFBUSxRQUFRLEVBQUU7Z0JBQ2hCLEtBQUssT0FBTztvQkFDVixPQUFPO3dCQUNMLFNBQVMsRUFBSyxTQUFTLHlCQUFzQjt3QkFDN0MsWUFBWSxFQUFLLFNBQVMseUJBQXNCO3dCQUNoRCxXQUFXLEVBQUssU0FBUyxpQkFBWSxVQUFZO3dCQUNqRCxJQUFJLEVBQUUsQ0FBQzt3QkFDUCxHQUFHLEtBQUE7cUJBQ0osQ0FBQztnQkFDSixLQUFLLE1BQU07b0JBQ1QsT0FBTzt3QkFDTCxTQUFTLEVBQUssU0FBUyx5QkFBc0I7d0JBQzdDLFlBQVksRUFBSyxTQUFTLHlCQUFzQjt3QkFDaEQsVUFBVSxFQUFLLFNBQVMsaUJBQVksVUFBWTt3QkFDaEQsS0FBSyxFQUFFLENBQUM7d0JBQ1IsR0FBRyxLQUFBO3FCQUNKLENBQUM7Z0JBQ0osS0FBSyxRQUFRO29CQUNYLE9BQU87d0JBQ0wsVUFBVSxFQUFLLFNBQVMseUJBQXNCO3dCQUM5QyxXQUFXLEVBQUssU0FBUyx5QkFBc0I7d0JBQy9DLFlBQVksRUFBSyxTQUFTLGlCQUFZLFVBQVk7d0JBQ2xELEdBQUcsRUFBRSxDQUFDO3dCQUNOLElBQUksTUFBQTtxQkFDTCxDQUFDO2dCQUNKLEtBQUssS0FBSyxDQUFDO2dCQUNYO29CQUNFLE9BQU87d0JBQ0wsVUFBVSxFQUFLLFNBQVMseUJBQXNCO3dCQUM5QyxXQUFXLEVBQUssU0FBUyx5QkFBc0I7d0JBQy9DLFNBQVMsRUFBSyxTQUFTLGlCQUFZLFVBQVk7d0JBQy9DLE1BQU0sRUFBRSxDQUFDO3dCQUNULElBQUksTUFBQTtxQkFDTCxDQUFDO2FBQ0w7UUFDSCxDQUFDLENBQUMsRUFBRSxDQUNtQixDQUFBO0lBdkR6QixDQXVEeUIsRUFDM0I7UUFDRSxVQUFVO1FBQ1YsU0FBUztRQUNULFNBQVMsQ0FBQyxNQUFNO1FBQ2hCLFNBQVMsQ0FBQyxJQUFJO1FBQ2QsU0FBUyxDQUFDLEdBQUc7UUFDYixTQUFTLENBQUMsS0FBSztRQUNmLFdBQVcsQ0FBQyxNQUFNO1FBQ2xCLFdBQVcsQ0FBQyxJQUFJO1FBQ2hCLFdBQVcsQ0FBQyxHQUFHO1FBQ2YsV0FBVyxDQUFDLEtBQUs7UUFDakIsUUFBUTtLQUNULENBQ0YsQ0FBQztJQUVGLE9BQU87UUFDTCxtQkFBbUIscUJBQUE7UUFDbkIsVUFBVSxZQUFBO0tBQ1gsQ0FBQztBQUNKLENBQUMsQ0FBQztBQTVGVyxRQUFBLGlCQUFpQixxQkE0RjVCIn0=